(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["volices-gift-offer"] && !Shopify.designMode) return;
  try {
    const initializeVolicesGiftInformation = () => {
  document.querySelectorAll('[data-volices-gift-source]:not([data-volices-gift-ready])').forEach((source) => {
    source.setAttribute('data-volices-gift-ready', '');
    const scope = source.parentElement;
    if (!scope) return;
    let scheduled = false;
    const synchronize = () => {
      scheduled = false;
      const offers = Array.from(scope.querySelectorAll('.fg-gift-thumbnail-offer'));
      const offer = offers.find((candidate) => /^Tissot\b/i.test(candidate.querySelector('img')?.alt || ''));
      if (!offer) {
        source.hidden = false;
        return;
      }
      offer.setAttribute('data-volices-gift-enhanced', '');
      const header = offer.querySelector('.fg-gift-thumbnail-offer-header');
      const footer = offer.querySelector('.fg-gift-thumbnail-offer-footer');
      if (!offer.querySelector('[data-volices-gift-explanation]')) {
        const explanation = source.querySelector('[data-volices-gift-explanation]')?.cloneNode(true);
        if (explanation) {
          if (header) header.after(explanation);
          else offer.prepend(explanation);
        }
      }
      if (!offer.querySelector('[data-volices-gift-link]')) {
        const link = source.querySelector('[data-volices-gift-link]')?.cloneNode(true);
        if (link) {
          if (footer) footer.before(link);
          else offer.append(link);
        }
      }
      offer.querySelectorAll('.gift-original-url').forEach((link) => {
        const image = link.querySelector('img');
        const title = image?.alt?.trim();
        if (!title) return;
        let caption = link.querySelector('.volices-gift-caption');
        if (!caption) {
          caption = document.createElement('span');
          caption.className = 'volices-gift-caption';
          link.append(caption);
        }
        if (caption.textContent !== title) caption.textContent = title;
      });
      source.hidden = true;
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(synchronize);
    };
    synchronize();
    new MutationObserver(schedule).observe(scope, { childList: true, subtree: true });
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeVolicesGiftInformation, { once: true });
} else {
  initializeVolicesGiftInformation();
}
document.addEventListener('shopify:section:load', initializeVolicesGiftInformation);
  } catch(e) { console.error(e); }
})();

})();
